const commonDefaultState = {
  currentTokenValue: null,
}

export default commonDefaultState
